<template>
  <div style="color:#fff" class="rightBar">
    <v-drawer class="right-drawer" :direction="'right'" :width="'26%'">
      <div class="animated fadeInRightBig" style="height:100%;width:100%;">
        <bar-card class="lefts" :bg="'border2'">
          <v-title>本地物流监控点发货情况</v-title>
          <bar2
            :datas="data1"
            unit="业务量（件）"
            :title="title1"
            class="panelContent"
            :haszoom="false"
            sname="业务量"
          />
        </bar-card>
        <bar-card class="lefts" :bg="'border2'">
          <v-title>
            荔枝运输高速绿通抽样车辆
          </v-title>
          <line1
            unit="辆"
            :datas="sldata"
            :title="sltitle"
            class="panelContent"
          ></line1>
        </bar-card>
        <bar-card class="lefts" :bg="'border2'">
          <v-title>
            运输到各省抽样车辆情况
          </v-title>
          <bar2
            unit="车辆"
            :datas="data2"
            :title="title2"
            class="panelContent"
            :haszoom="true"
            sname="车辆数量"
          />
        </bar-card>
      </div>
    </v-drawer>
  </div>
</template>

<script>
import line1 from "./components/line/common/lineCommon1";
import bar2 from "./components/bar/common/barCommon4";
import { get } from "@/api/index";
export default {
  components: {
    line1,
    bar2
  },
  data() {
    return {
      data2: [],
      title2: "",
      sldata: [],
      sltitle: ""
    };
  },
  computed: {
    data1() {
      const data = this.$store.state.schj.datas;
      if (data.logisticsStateList) {
        return data.logisticsStateList.map(e => {
          return {
            name: e.date,
            value: e.quantity
          };
        });
      } else {
        this.getDt();
        return [];
      }
    },
    title1() {
      const data = this.$store.state.schj.datas;
      if (data.logisticsStateList) {
        const nums = data.logisticsStateList.reduce((pre, cur) => {
          return pre + cur.quantity;
        }, 0);
        const wnums = (nums / 10000).toFixed(2);
        return `累计${wnums}万件`;
      } else {
        return "";
      }
    }
  },
  mounted() {
    get("/api/restful/procure/car_num").then(res => {
      this.sldata = res.reverse().map(e => {
        return {
          date: e.date,
          price: e.num
        };
      });
      // 计算总数
      const all = res.reduce((pre, cur) => {
        return pre + Number(cur.num);
      }, 0);
      this.sltitle = `累计${all}辆`;
    });
    // old 各镇采购商总数
    // get("/api/restful/procure/cgs_area_total").then(res => {
    //   if (res instanceof Array) {
    //     this.data1 = res.map(e => {
    //       return {
    //         name: e.name,
    //         value: e.num
    //       };
    //     });
    //   }
    // });
    get("/api/restful/procure/province_car_num").then(res => {
      if (res instanceof Array) {
        // 计算总数
        const all = res.reduce((pre, cur) => {
          return pre + Number(cur.num);
        }, 0);
        this.title2 = `累计${all}辆`;
        this.data2 = res.map(e => {
          return {
            name: e.name,
            value: e.num
          };
        });
      }
    });
  },
  methods: {
    getDt() {
      get("../ywtg_service/api/getyztdata").then(res => {
        const data = res.data;
        try {
          const { marketPriceList, logisticsStateList } = data;
          this.$store.dispatch("schj/setDatas", {
            marketPriceList,
            logisticsStateList
          });
        } catch (err) {
          console.log(err);
        }
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.right-drawer
  >>>.side
    top 105px

.panelContent
  height calc(100% - 43px)
  color #fff
.lefts
  height calc(33% - 10px)
  // height 40%
  margin-bottom 10px
.lefts2
    height calc(65% - 10px)
@media (min-height 1400px)
  .rightBar
    >>>.side
      width 24% !important
</style>
